module.exports = __webpack_public_path__ + "img/back-icon.4398f397.svg";